/**
 * @desc 缓动函数
 * [摘自](https://github.com/bameyrick/js-easing-functions)
 */
export default function easeInOut(elapsed: number, initialValue: number, amountOfChange: number, duration: number): number {
    if ((elapsed /= duration / 2) < 1) {
        return (amountOfChange / 2) * elapsed * elapsed * elapsed + initialValue;
    }
    return (amountOfChange / 2) * ((elapsed -= 2) * elapsed * elapsed + 2) + initialValue;
}
